/**
 * @description 联系销售
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
export interface IInputContactSales {
    first_name: string;
    last_name: string;
    phone: string;
    email: string;
    enterprise_name: string;
    position_name: string;
}

export type IOutputContactSales = IResponse<{ [status: string]: 0 | 1 } | {}>;

export const contactSales = (data: IInputContactSales) => {
    return fetchData(Api.CONTACT_SALES, data).then((res: IOutputContactSales) => {
        return res;
    });
};
